/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function($) {


    if (window.matchMedia("(max-width: 767px)").matches) {
      // Viewport is less or equal to 700 pixels wide
    } else {
      // Viewport is greater than 700 pixels wide
    }

$('.hint-description').appendTo('body')
  
 $('.hint-block .hint').on({
    mouseenter: function () {
      var dataHint = $(this).data('hint');
      var mouseX = 0, mouseY = 0;
      var xp = 0, yp = 0;
     
        $(this).mousemove(function(e){
          mouseX = e.pageX ;
          mouseY = e.pageY ; 

         $('.hint-description').each(function(){
            if ($(this).data('hint-desc') == dataHint) {
              
               $(this).addClass('hint-hovered');
              if ($(this).hasClass('hint-hovered')) {
      
              
        
                $(this).css({
                top: mouseY + 20 +'px',
                left: mouseX - $(this).outerWidth() + 30 + 'px'
                })
                 var pos = $(this).position(),
                     posX = pos.left;
                
                 console.log(posX);
                if (posX < 0 || posX == 15 ) {
                  $(this).css('left', '15px');
               }
            } else {
                $(this).removeClass('hint-hovered');
              }
            }
          })
        });
      
      
    },
    mouseleave: function () {
      $('.hint-description').removeClass('hint-hovered');
    }
});


    $(document).ready(function() {
	   
    });
})(jQuery);

(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


